const STORAGE_KEY = 'nlims_collection_sync';
const EVENT_NAME = 'nlims:collection-changed';

function hasWindow() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function buildCollectionSyncPayload(collectionKey, detail = {}) {
  return {
    collectionKey,
    ...detail,
    ts: Date.now(),
    nonce: Math.random().toString(36).slice(2),
  };
}

export function publishCollectionChange(collectionKey, detail = {}) {
  if (!collectionKey || !hasWindow()) return null;

  const payload = buildCollectionSyncPayload(collectionKey, detail);

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch (error) {
    // Storage can fail in private mode or if quota is exceeded.
    console.warn('[CollectionSync] Failed to persist sync payload', error);
  }

  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload }));
  return payload;
}

export function readCollectionChangePayload(rawValue) {
  if (!rawValue) return null;
  try {
    const payload = JSON.parse(rawValue);
    return payload && typeof payload === 'object' ? payload : null;
  } catch {
    return null;
  }
}

export function collectionSyncStorageKey() {
  return STORAGE_KEY;
}

export function collectionSyncEventName() {
  return EVENT_NAME;
}
